import { FormControl, FormControlProps, TextField, TextFieldProps, styled } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { useCallback, useMemo } from 'react';
import targetAudienceOptionsFormAtom, {
  targetAudienceOptionsAtom,
  writeTargetAudienceOptionFormAtom,
} from './atom';

const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '8px',
  paddingRight: 0,
  transition: 'all 500ms ease-in-out',
  width: '100%',
  border: 'none',
  '& .MuiInputBase-input': {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export interface TargetAudienceTextFormProps extends FormControlProps {}

const TargetAudienceTextForm: React.FC<TargetAudienceTextFormProps> = ({
  fullWidth = true,
  id = '',
  ...props
}) => {
  const items = useAtomValue(targetAudienceOptionsAtom);
  const setTargetAudienceFormOption = useSetAtom(writeTargetAudienceOptionFormAtom);
  const activeItems = useAtomValue(targetAudienceOptionsFormAtom);
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: string) => {
      const {
        target: { value },
      } = event;
      setTargetAudienceFormOption({
        key,
        // On autofill we get a stringified value.
        value: value,
      });
    },
    [setTargetAudienceFormOption],
  );

  const data = useMemo(() => {
    if (id) {
      const v = items[id];
      if (v) {
        return v;
      }
    }
    return undefined;
  }, [id, items]);

  return (
    <Grid2 xs={12}>
      <FormControl {...props} {...{ fullWidth }}>
        <StyledTextField
          onChange={(e) => {
            handleChange(e, id);
          }}
          fullWidth
          value={(activeItems || {})[id]}
          defaultValue={(activeItems || {})[id] || ''}
          name={id}
          {...data}
        />
      </FormControl>
    </Grid2>
  );
};
export default TargetAudienceTextForm;
